export const TERRA_ASSETS = 'https://assets.terra.money';
export const FINDER = 'https://finder.terra.money';

export const DEFAULT_DECIMALS = 6;
